import { connect } from 'react-redux';
import JournalPartnerTagsAdminScreen from '../components/JournalPartnerTagsAdminScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    total: state.journalPartnerTagsAdmin.get('total'),
    isLoading: state.journalPartnerTagsAdmin.get('isLoading'),
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const JournalPartnerTagsAdminScreenContainer = connect(mapStateToProps)(
  JournalPartnerTagsAdminScreen
);

export default JournalPartnerTagsAdminScreenContainer;
